import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const postVotation = createAsyncThunk(
  "crear/votaciones",
  async (vote, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://harmastudio-dev-69b634b453a9.herokuapp.com/api/prospects/vote",
        { vote },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Respuesta del servidor:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error en la solicitud:", error);
      console.error("Detalles del error:", error.response); // Esto te dará detalles completos sobre el error.
      return rejectWithValue(
        error.response?.data?.message || "Failed to create votation"
      );
    }
  }
);

export const getVotaciones = createAsyncThunk(
  "get/votaciones",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://harmastudio-dev-69b634b453a9.herokuapp.com/api/prospects/votes"
      );
      console.log(response.data);

      return response.data;
    } catch (error) {
      console.error(error.response?.data?.message);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch votations"
      );
    }
  }
);

export const getVotacionesCount = createAsyncThunk(
  "get/votacionesCount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        "https://harmastudio-dev-69b634b453a9.herokuapp.com/api/prospects/votes/count"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to get votations count"
      );
    }
  }
);

export const sendFormVotates = createAsyncThunk(
  "prospects/form",
  async (prospect, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "https://harmastudio-dev-69b634b453a9.herokuapp.com/api/prospects/",
        prospect
      );
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message:
          error.response?.data?.message || "Error al enviar el formulario",
        status: error.response?.status || 500,
      });
    }
  }
);

///prospect/vote  vote: vote;1,2,3,4
//*  propsects/votes, get, []
//* prospects/votes/count , get 1

// Estado inicial del slice
const initialState = {
  loading: false,
  error: null,
  votaciones: [],
  vote: null,
  votacionesCount: null,
};

// Reducer y extraReducers
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postVotation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postVotation.fulfilled, (state, action) => {
        state.loading = false;
        state.vote = action.payload;
      })
      .addCase(postVotation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getVotaciones.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVotaciones.fulfilled, (state, action) => {
        state.loading = false;
        state.votaciones = action.payload;
      })
      .addCase(getVotaciones.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getVotacionesCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVotacionesCount.fulfilled, (state, action) => {
        state.loading = false;
        state.votacionesCount = action.payload.count;
      })
      .addCase(getVotacionesCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = userSlice.actions;
export default userSlice.reducer;
